import React from 'react';
import { Link } from 'react-router-dom';

import Comunicado from 'Component/Comunicado';
import { useRecuperarComunicadosQuery } from 'View/Service/Default/Comunicados';

const Comunicados = (): React.ReactElement => {
  const { data: { comunicados } = {} } = useRecuperarComunicadosQuery({
    contain: ['Usuarios'],
    sort: 'modificado',
    direction: 'desc',
    limit: 2,
  });

  return (
    <div className="bg-white rounded shadow-sm">
      <div className="bg-primary text-white rounded-top py-2 px-3 fs-4 d-flex justify-content-between align-items-center">
        Comunicados
        <Link
          to="/comunicados/todos"
          className="text-white text-decoration-none fs-6"
        >
          Ver todos
        </Link>
      </div>
      <div className="p-3 hf-500 overflow-auto rounded">
        {comunicados?.map((comunicado, indice) => (
          <Comunicado
            key={`${comunicado.id}-${comunicado.modificado}`}
            dados={comunicado}
            indice={indice}
          />
        ))}
      </div>
    </div>
  );
};

export default Comunicados;
